// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__MuuFC","clinicsSelect":"TableHeading_clinicsSelect__2pnUx"};